module.exports = __webpack_public_path__ + "static/media/Vintagesignreproduction2004Acryliconwoodpanel.5ccf55aa.webp";